import React from "react";
import { connect } from "react-redux";
import { push as changeURL } from "react-router-redux";

import mapDispatch from "~/misc/mapDispatch";
import { modalChange } from "~/modules/modal/actions";
import * as modes from "~/modules/modal/modes";
import * as urls from '~/routing/urls';
import { changShowCardAction } from "../../state/action";

import DetailFrom from "../DetailForm";
import { POSTTRUCKSHOWTYPE } from "../../utils";

class DetailCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailData: this.props.detail,
      showType: this.props.type,
    };
  }
  componentWillUnmount() {
    this.props.changeShowCard(POSTTRUCKSHOWTYPE.LIST);
  }
  cancelAction = () => {
    const { type, goBackToAlert, changeShowCard} = this.props;
    if(type === POSTTRUCKSHOWTYPE.DETAIL_LOADALERT) {
      return goBackToAlert();
    }
    return changeShowCard(POSTTRUCKSHOWTYPE.LIST)
  }
  render() {
    return <DetailFrom 
      cancelAction={this.cancelAction}
    />;
  }
}

export default connect(
  (state, ownProps) => {
    return {
      ...state.postTruck,
      ...ownProps,
    };
  },
  mapDispatch({
    showRateModal: (props, { orgin, destination }) =>
      modalChange(modes.POSTTRUCK_RATE, {
        type: "askPop",
        orgin,
        destination,
      }),
    changeShowCard: (props, type) => changShowCardAction(type),
    goBackToAlert: (props, value) => changeURL(`${urls.ALERT}/list`),
  })
)(DetailCard);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/DetialCard/index.js